import { Component } from '@angular/core';

@Component({
  selector: 'rs-applicant-information',
  templateUrl: 'applicant-information.component.html'
})
export class ApplicantInformationComponent {}
